import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactSection from './ContactSection';

export default function PageLayout({ children, contactCta = true }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      {/* Offset matches the fixed header height (h-16 / lg:h-[84px]) */}
      <main className="flex-1 pt-16 lg:pt-[84px]">{children}</main>
      {contactCta && <ContactSection />}
      <Footer />
    </div>
  );
}
